module.exports = __webpack_public_path__ + "static/media/new_logo.366e70a4.png";